var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.hasPendingChanges)?_c('span',{staticClass:"kpi-pending-changes-badge"},[_vm._v("Pending Changes")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }